import maplibregl from 'maplibre-gl'
import { Protocol } from 'pmtiles'

let protocolRegistered = false

/**
 * Регистрирует PMTiles протокол для MapLibre GL
 * Позволяет использовать pmtiles:// URL в источниках карты
 *
 * @example
 * ```json
 * {
 *   "sources": {
 *     "mymap": {
 *       "type": "vector",
 *       "url": "pmtiles:///map-data/vko.pmtiles"
 *     }
 *   }
 * }
 * ```
 */
export function registerPMTilesProtocol() {
  if (protocolRegistered) {
    return
  }

  const protocol = new Protocol()
  maplibregl.addProtocol('pmtiles', protocol.tile)

  protocolRegistered = true
  console.log('✓ PMTiles protocol registered')
}
